import { render, staticRenderFns } from "./MarkaPatentHacziForm.vue?vue&type=template&id=4d22c98d&scoped=true"
import script from "./MarkaPatentHacziForm.vue?vue&type=script&lang=ts"
export * from "./MarkaPatentHacziForm.vue?vue&type=script&lang=ts"
import style0 from "./MarkaPatentHacziForm.vue?vue&type=style&index=0&id=4d22c98d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d22c98d",
  null
  
)

export default component.exports